import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { darkModeClass } from '../../utils/cn';
import styles from './Experience.module.css';

const Experience = () => {
  const { isDarkMode } = useTheme();
  const { data, t } = useLanguage();
  const experienceData = data.experience;

  return (
    <section id="experience" className={`${styles.experience} ${darkModeClass(styles, isDarkMode)}`}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{t('experience.title')}</h2>
          <p className={styles.sectionSubtitle}>{t('experience.subtitle')}</p>
        </div>
        
        <div className={styles.timeline}>
          {experienceData.map((item, index) => (
            <div key={index} className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineContent}>
                <span className={styles.timelineDate}>{item.date}</span>
                <h3 className={styles.timelineTitle}>{item.title}</h3>
                <p className={styles.timelineSubtitle}>{item.subtitle}</p>
                
                {item.description && (
                  <ul className={styles.timelineDescription}>
                    {item.description.map((point, pointIndex) => (
                      <li key={pointIndex}>{point}</li>
                    ))}
                  </ul>
                )}
                
                {item.technologies && (
                  <div className={styles.timelineTech}>
                    {item.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className={styles.techTag}>{tech}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(Experience);